$(function(){
    const heroSlider = new Swiper('.js-hero-slider', {
      slidesPerView: 1,
      loop: true,
      speed: 500,
      pagination: {
        el: '.js-slider-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.js-slider-arrow-next',
      },
    });

    if ($('.js-awards-slider').length) {
      const sliderEl = $('.js-awards-slider')
      const paginationEl = sliderEl.parent().find('.js-slider-pagination')[0]
      const navNextEl = sliderEl.parent().find('.js-slider-arrow-next')[0]

      const awardsSlider = new Swiper('.js-awards-slider', {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: navNextEl,
        },
      });
    }

    if ($('.js-article-slider').length) {
      const articleSliderElement = $('.js-article-slider')[0]
      const articleSliderThumbsElement = $('.js-article-thumbs-slider').length ? $('.js-article-thumbs-slider')[0] : null
      
      if (!!articleSliderThumbsElement) {
        var articleSliderThumbs = new Swiper(articleSliderThumbsElement, {
          spaceBetween: 6,
          slidesPerView: 4,
          // freeMode: true,
          // watchSlidesProgress: true,
          allowTouchMove: false,
          // loop: true, bug detected - loops only through previous ones
          navigation: {
            prevEl: articleSliderThumbsElement.parentNode.querySelector('.js-slider-arrow-prev'),
            nextEl: articleSliderThumbsElement.parentNode.querySelector('.js-slider-arrow-next'),
          },
          breakpoints: {
            1024: {
              spaceBetween: 11,
            },
            1680: {
              spaceBetween: 20,
            },
          },
        })
      }

      let thumbsObj = null
      if (!!articleSliderThumbsElement) {
        thumbsObj = {
          swiper: articleSliderThumbs,
        }
      }
      
      window.productSlider = new Swiper(articleSliderElement, {
        // effect: 'fade',
        speed: 500,
        // loop: true,
        // fadeEffect: {
        //   crossFade: true
        // },
        thumbs: thumbsObj,
        navigation: {
          prevEl: articleSliderElement.querySelector('.js-slider-arrow-prev'),
          nextEl: articleSliderElement.querySelector('.js-slider-arrow-next'),
          // disabledClass: 'disabled'
        },
      })
    }

    
    if ($('.js-content-slider-gallery').length) {
      const sliderEl = $('.js-content-slider-gallery')
      const paginationEl = sliderEl.parent().find('.js-slider-pagination')[0]
      const navNextEl = sliderEl.parent().find('.js-slider-arrow-next')[0]

      const slider = new Swiper(sliderEl[0], {
        slidesPerView: 1,
        loop: true,
        speed: 500,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: navNextEl,
        },
      })
    }

    if ($('.js-widget-slider').length) {
      const sliderEl = $('.js-widget-slider')
      let countDelta = 0
      const counterCurrent = sliderEl.find('.js-slider-count-current')
      const counterTotal = sliderEl.find('.js-slider-count-total')

      const slider = new Swiper(sliderEl[0], {
        slidesPerView: 1,
        loop: false,
        speed: 500,
        navigation: {
          prevEl: sliderEl.find('.js-slider-arrow-prev')[0],
          nextEl: sliderEl.find('.js-slider-arrow-next')[0],
        },
        on: {
          init: function(swiper) {
              if (swiper.passedParams.loop) countDelta = 2
              const currentSlideIndex = swiper.realIndex + 1              
              counterCurrent.text(currentSlideIndex.toString())
              counterTotal.text(`/ ${swiper.slides.length - countDelta}`)
          },
          slideChange: function(swiper) {
              const currentSlideIndex = swiper.realIndex + 1
              counterCurrent.text(currentSlideIndex.toString())
          }
        },
      })

    }

    // if ($('.progress-item.in-progress').length) {
    if ($('.js-progress-item').length) {
      if (typeof donationData !== 'undefined') {
        if (donationData.collectedAmount < 500000) {
          $('.js-progress-item').eq(0).addClass('in-progress')
        }
        else if (donationData.collectedAmount >= 500000 && donationData.collectedAmount < 1000000) {
          $('.js-progress-item').eq(1).addClass('in-progress')
        }
        else if (donationData.collectedAmount >= 1000000 && donationData.collectedAmount < 2000000) {
          $('.js-progress-item').eq(2).addClass('in-progress')
        }
        else if (donationData.collectedAmount >= 2000000 && donationData.collectedAmount < 4000000) {
          $('.js-progress-item').eq(3).addClass('in-progress')
        }
      }
      let slidesHTML = ''
      let i = 15
      while (i > 0) {
        slidesHTML += `<div class="swiper-slide">
                                        <picture>
                                            <source media="(min-width: 768px)" srcset="${arrowsPaths.right}" />
                                            <img src="${arrowsPaths.down}">
                                        </picture>
                                    </div>`
        i--
      }
      const sliderHTML = `<div class="swiper js-marquee-slider">
    <div class="swiper-wrapper">${slidesHTML}</div>
</div>`
      $('.progress-item.in-progress .progress-item__bar').append(sliderHTML)

      setTimeout(()=> {
        const sliderElement = $('.js-marquee-slider')[0]
        let marqueeSlider
        const sliderMobParams = {
          direction: 'vertical',
          speed: 1000,
          autoplay: {
            delay: 1,
            reverseDirection: true,
          },
          loop: true,
          slidesPerView: 'auto',
          allowTouchMove: false,
          centeredSlides: true,
        }
        const sliderUnMobParams = {
          speed: 1000,
          autoplay: {
            delay: 1,
            reverseDirection: true,
          },
          loop: true,
          slidesPerView: 'auto',
          allowTouchMove: false,
          centeredSlides: true,
        }
  
        const breakpoint = window.matchMedia('(min-width:768px)')
        const breakpointChecker = function() {
          if ( marqueeSlider !== undefined ) marqueeSlider.destroy( true, true );
  
          if (breakpoint.matches) {
            marqueeSlider = new Swiper(sliderElement, sliderUnMobParams)
          } else {
            marqueeSlider = new Swiper(sliderElement, sliderMobParams)
          }
        }
        breakpoint.addEventListener('change', breakpointChecker)
        breakpointChecker();
      }, 200)
    }
})